import { makeAutoObservable, runInAction } from "mobx";
import { onB2BError } from "@/utils/b2bErrors";
/**
 * Сводка и тариф активной компании кабинета (UC1130) — `corp_my_companies` + `corp_my_tariff`.
 * Kill-switch (пустой ответ/`42501`) уже обёрнут в `CorpCompanyService` (`withCorpGuard`/`assertCompanyPresent`) —
 * стор только перечитывает principal через ошибку, всплывающую из сервиса.
 */
export class CorpCompanyStore {
    constructor(companyService) {
        this.companyService = companyService;
        this.summary = null;
        this.tariff = null;
        this.isLoading = false;
        this.generation = 0;
        makeAutoObservable(this, {
            companyService: false,
            generation: false,
        });
    }
    async load(companyId) {
        const generation = ++this.generation;
        this.isLoading = true;
        try {
            const [summary, tariff] = await Promise.all([
                this.companyService.getSummary(companyId),
                this.companyService.getTariff(companyId),
            ]);
            runInAction(() => {
                if (generation !== this.generation)
                    return;
                this.summary = summary;
                this.tariff = tariff;
            });
        }
        catch (error) {
            // Kill-switch (42501/пустой corp_my_companies) уже обработан в сервисе — здесь только сообщение.
            onB2BError(error, "Не удалось загрузить сводку компании", "corpCabinet");
        }
        finally {
            runInAction(() => {
                if (generation === this.generation)
                    this.isLoading = false;
            });
        }
    }
    get creditState() {
        return this.summary?.creditState ?? null;
    }
    get banners() {
        return this.summary?.banners ?? [];
    }
    dispose() {
        this.generation += 1;
        this.summary = null;
        this.tariff = null;
        this.isLoading = false;
    }
}
